// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#broadcast-send-modal .modal-dialog{container:form-input/inline-size}#broadcast-send-modal footer button.btn{width:auto}@container form-input (inline-size < 625px){#broadcast-send-modal .preview-body{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}#broadcast-send-modal .preview-body .preview{width:100%;border-left:none;border-top:1px solid #e6ebed}}", ""]);
// Exports
module.exports = exports;
